module.exports = "/_next/static/images/e4693699847940c973856d621e1668f6-xpeer-fgts@0.5x.jpg.webp";